import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import {
  companyName,
  duration,
  initialSettings,
  optionssymbol,
  priorityList,
  project,
  salestypelist,
  socialMedia,
  contactStatus,
  status,
  tagInputValues,
  all_tags,
} from "../../../core/common/selectoption/selectoption";
import { MdMail } from "react-icons/md";

import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { contactData } from "../../../core/data/json/contactData";
import Table from "../../../core/common/dataTable/index";
import { Modal } from "react-bootstrap";
import { TableData } from "../../../core/data/interface";
import CreatableSelect from "react-select/creatable";
import { useDispatch, useSelector } from "react-redux";
import { HiEllipsisVertical } from "react-icons/hi2";
import * as XLSX from "xlsx";
import "./leads.css";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
  setAddTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import { TagsInput } from "react-tag-input-component";
import { all_routes } from "../../router/all_routes";
import DatePicker from "react-datepicker";
import DefaultEditor from "react-simple-wysiwyg";
import CollapseHeader from "../../../core/common/collapse-header";
import { SelectWithImage } from "../../../core/common/selectWithImage";
import { SelectWithImage2 } from "../../../core/common/selectWithImage2";
import { MdDoubleArrow } from "react-icons/md";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { utils, writeFile } from "xlsx";
import EditCell from "../../../core/common/editCell/EditCell";
import AvatarInitialStyles from "../../../core/common/nameInitialStyles/AvatarInitialStyles";
import { CiEdit } from "react-icons/ci";
import CustomerOffcanvas from "../../../core/common/offCanvas/customer/CustomerOffcanvas";
import { setPhone } from "../../../core/data/redux/slices/appCommonSlice";
import { useWizard, Wizard } from "react-use-wizard";
import api from "../../../core/axios/axiosInstance";
import { showToast } from "../../../core/data/redux/slices/ToastSlice";
import {
  saveBulkContacts,
  fetchContactsWithCache,
  clearContactsCache,
  clearContactDetailsCache,
  updateContactInCache,
  setCurrentPage,
  setPageLimit,
  setSearchQuery,
  setSelectedContactStatus,
  setSelectedIsFavourite,
} from "../../../core/data/redux/slices/LeadSlice";
import {
  resetSelectedContact,
  setSelectedContact,
} from "../../../core/data/redux/slices/SelectedContactSlice";
import {
  getAllContactsOrLeads,
  changeContactStatus,
  deleteContactOrLead,
  toggleContactFavorite,
  batchDeleteContacts,
  updateFirstPhoneOrEmail,
} from "../../../core/api/contactApi";
import {
  openDialer,
  setPhoneNumber,
  setCallerAndNumber,
} from "../../../core/data/redux/slices/FloatingDialerSlice";
import { setActiveContact } from "../../../core/data/redux/slices/ActiveContactSlice";
import CountryCodePrompt from "../components/CountryCodePrompt";
import CallerSelectionModal from "../components/CallerSelectionModal";
import EmailTemplateModal from "../../common/EmailTemplateModal";
import WhatsappTemplateModal from "../../common/WhatsappTemplateModal";
import { addTag, fetchTags } from "../../../core/data/redux/slices/TagSlice";
const ContactList = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.profile);
  const [callerModalTarget, setCallerModalTarget] = useState(null); // { phone }
  // Basic UI state
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [activeRecordKey, setActiveRecordKey] = useState(null);
  const [importModal, setImportModal] = useState(false);
  const [statusContact, setStatusContact] = useState({});
  const [activeCell, setActiveCell] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredRecord, setHoveredRecord] = useState(null);
  const [selectedDate1, setSelectedDate1] = useState(new Date());
  const [agents, setAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedExcelFileName, setSelectedExcelFileName] = useState("");
  const [showCountryCodePrompt, setShowCountryCodePrompt] = useState(false);
  const [filterTags, setFilterTags] = useState([]);
  const [pendingImportProvider, setPendingImportProvider] = useState(null);
  const [selectedContactKeys, setSelectedContactKeys] = useState([]); // For batch delete
  const [selectedContactRows, setSelectedContactRows] = useState([]); // Full row data
  const [showBatchDeleteModal, setShowBatchDeleteModal] = useState(false);
  const [parsedExcelContacts, setParsedExcelContacts] = useState([]);
  const [previousTags, setPreviousTags] = useState([]);
  const [newTags, setNewTags] = useState([]);
  const [removedTags, setRemovedTags] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);


  const assignOptions = [
    { label: "Assign", value: true },
    { label: "Unassign", value: false },
  ];
  const [selectedAssign, setSelectedAssign] = useState(assignOptions[0]);


  const [bulkSelectedTags, setBulkSelectedTags] = useState([]);
  const [bulkAllTags, setBulkAllTags] = useState([]);
  const [bulkNewTags, setBulkNewTags] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState([]);

  const [allTags, setAllTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [activeGroupEdit, setActiveGroupEdit] = useState(null);
  const [columnVisibility, setColumnVisibility] = useState({
    "": true,
    Name: true,
    Phone: true,
    Company: false,
    Email: true,
    Designation: false,
    // Website: false,
    "Contact Status": true,
    Action: false,
    "Created By": userProfile.role === "companyAdmin",
    "Assigned to": userProfile.role === "companyAdmin",
    Groups: true
  });
  // Auto-open import modal when navigated from the setup guide
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("openImport") === "1") {
      setImportModal(true);
    }
  }, [location.search]);

  useEffect(() => {
    dispatch(fetchTags());
  }, [dispatch]);
  // API State - Use Redux for contacts and pagination
  const contactsState = useSelector((state) => state.leads);
  const contacts = contactsState.contacts;
  const loading = contactsState.loading;
  const pagination = contactsState.pagination;
  const { tags } = useSelector((state) => state.tags);

  const activeContact = useSelector(
    (state) => state.activeContact.activeContact
  );

  const selectedContact = activeContact
  // Get filter/pagination values from Redux
  const currentPage = contactsState.currentPage;
  const pageLimit = contactsState.pageLimit;
  const searchQuery = contactsState.searchQuery;
  const selectedContactStatus = contactsState.selectedContactStatus;
  const selectedIsFavourite = contactsState.selectedIsFavourite;

  useEffect(() => {
    const tagsArrayOfObject = tags.map((tag) => {
      return {
        value: tag.tag,
        label: `${tag.emoji}${" "}${tag.tag}`,
        emoji: tag.emoji,
      };
    });
    setAllTags(tagsArrayOfObject);
  }, [tags]);

  // Redux selectors
  const activityToggle = useSelector((state) => state?.activityTogglePopup);
  const activityToggleTwo = useSelector(
    (state) => state?.activityTogglePopupTwo
  );
  const addTogglePopupTwo = useSelector((state) => state?.addTogglePopupTwo);

  const agentOptions = agents.map(agent => ({
    label: `${agent.firstname} ${agent.lastname}`, // what the user sees
    value: agent._id, // what will be sent to API
  }));


  const handleBulkAssignAgent = async () => {
    if (!selectedAgent) {
      alert("Please select an agent!");
      return;
    }

    const payload = {
      assigned: selectedAssign.value, // or false if you want dynamic
      contact_ids: selectedContactKeys, // array of selected contact IDs
      agent_id: selectedAgent.value, // the selected agent ID
      category: "lead", // hardcoded
    };

    try {
      // const response = await fetch(
      //   "/addEditContactLeads/assignedContactLeadToAgent",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(payload),
      //   }
      // );
      console.log(payload, "jkhgfdghjklj");

      const response = await api.post("/addEditContactLeads/assignedContactLeadToAgent", payload)

      dispatch(
        showToast({ message: response.data.message, variant: "success" })
      );
 await fetchContacts();

      setSelectedContactKeys([])
    } catch (error) {
      console.error(error);
      alert("Error assigning agent");
    }
  };

  const contactStatusOptions =
    userProfile.leadStatuses && userProfile.leadStatuses.length > 0
      ? userProfile.leadStatuses
      : contactStatus; // Fallback to static if not available

  // Dynamic palette for statuses that have no color set
  const STATUS_PALETTE = [
    "#3C2371","#1890ff","#52c41a","#faad14","#f5222d",
    "#722ed1","#13c2c2","#eb2f96","#fa8c16","#a0d911",
  ];
  const hashStr = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
    return Math.abs(h);
  };
  const getStatusStyle = (statusValue) => {
    const matched = contactStatusOptions.find((s) => s.value === statusValue);
    const hex = matched?.color || STATUS_PALETTE[hashStr(statusValue || "") % STATUS_PALETTE.length];
    return {
      color: hex,
      backgroundColor: hex + "22", // ~13% opacity tint
      border: `1px solid ${hex}55`,
    };
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
  };
  const handleEditClick = (rowKey, columnKey) => {
    setActiveCell({ rowKey, columnKey });
  };
  const handleClose = () => {
    setActiveCell(null);
  };
  const handleUserTags = (tags) => {
    setSelectedTags(tags);

    // const tagsForApi = tags.map((tag) => tag.value);

    const removedTagsFilter = previousTags
      .filter((prevTag) => !tags.some((tag) => tag.value === prevTag.value))
      .map((tag) => tag.value);
    setRemovedTags(removedTagsFilter);
  };

  const handleCreateTag = async (inputValue) => {
    setNewTags([...newTags, { tag: inputValue, emoji: "🏷️" }]);
    setSelectedTags([
      ...selectedTags,
      { value: inputValue, label: `🏷️ ${inputValue}`, emoji: "🏷️" },
    ]);
  };
  const saveCellTags = async () => {
    try {
      if (newTags.length > 0) {
        await dispatch(addTag(newTags)).unwrap();
      }

      const payload = {
        contact_id: selectedContact.id,
        category: "lead",
        tags: selectedTags.map((tag) => ({
          tag: tag.value,
          emoji: tag.emoji,
        })),
      };

      const response = await api.post("/tag/assignedToContact", payload);
      fetchContacts()
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // Close edit popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeCell &&
        !event.target.closest(".popup") &&
        !event.target.closest(".editable-cell")
      ) {
        setActiveCell(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeCell]);
  const handleSaveField = async (key, field, value) => {
    try {
      if (field === "phone") {
        // PhoneInput returns value like "971539884139" (no + or space)
        // We need to send it as "+971539884139" to the backend
        const formattedValue = value.startsWith("+") ? value : `+${value}`;

        // Don't do optimistic update for phone - just call API and refetch
        // This ensures the display format matches what the backend returns

        // Call API with properly formatted phone
        const response = await updateFirstPhoneOrEmail({
          contact_id: key,
          field: field,
          value: formattedValue,
          category: "lead",
        });

        if (response.status === "success") {
          // Clear caches and refetch to ensure consistent formatting
          dispatch(clearContactDetailsCache(key));
          dispatch(clearContactsCache());
          await fetchContacts();

          dispatch(
            showToast({
              message: response.message || "Phone number updated successfully",
              type: "success",
            })
          );
        } else {
          dispatch(
            showToast({
              message: response.message || "Failed to update phone number",
              type: "error",
            })
          );
        }
      } else if (field === "email") {
        const updates = {
          emailAddresses: [value],
        };


console.log(key, field, value,"key, field, value");


        // Optimistically update the cache
        dispatch(
          updateContactInCache({
            contact_id: key,
            updates: updates,
          })
        );

        // Call API to update email

        console.log();
        
        const response = await updateFirstPhoneOrEmail({
          contact_id: key,
          field: field,
          value: value,
          category: "lead",
        });

        if (response.status === "success") {
          // Clear contact details cache so it refetches on next visit
          dispatch(clearContactDetailsCache(key));

          dispatch(
            showToast({
              message: response.message || "Email updated successfully",
              type: "success",
            })
          );
        } else {
          // If API fails, revert by clearing cache and refetching
          dispatch(
            showToast({
              message: response.message || "Failed to update email",
              type: "error",
            })
          );
          dispatch(clearContactDetailsCache(key));
          dispatch(clearContactsCache());
          await fetchContacts();
        }
      }
    } catch (error) {
      console.error(`Error updating ${field}:`, error);
      // Revert optimistic update by clearing cache and refetching
      dispatch(clearContactDetailsCache(key));
      dispatch(clearContactsCache());
      await fetchContacts();
      dispatch(
        showToast({
          message: error.response?.data?.message || `Failed to update ${field}`,
          type: "error",
        })
      );
    }
  };




















  const handleBulkCreateTag = (inputValue) => {
    const newTag = {
      value: inputValue,
      label: `🏷️ ${inputValue}`,
      emoji: "🏷️",
    };

    setBulkSelectedTags((prev) => [...prev, newTag]);
    setBulkNewTags((prev) => [
      ...prev,
      { tag: inputValue, emoji: "🏷️" },
    ]);
  };

  const handleBulkAssignTags = async () => {
    if (!selectedContactRows.length) {
      dispatch(
        showToast({
          message: "No contacts selected",
          variant: "warning",
        })
      );
      return;
    }

    if (!bulkSelectedTags.length) {
      dispatch(
        showToast({
          message: "Please select at least one tag",
          variant: "warning",
        })
      );
      return;
    }

    const payload = {
      contact_id: selectedContactRows.map(
        (row) => row._originalData.contact_id
      ),
      category: "lead",
      tags: bulkSelectedTags.map((tag) => ({
        tag: tag.value,
        emoji: tag.emoji,
      })),
    };

    try {
      if (bulkNewTags.length > 0) {
        await dispatch(addTag(bulkNewTags)).unwrap();
      }
      console.log(payload, "payload for bulk assign tags");

      const response = await api.post("/tag/assignedToMultipleContacts", payload)
      console.log(response.data, "response from bulk assign tags");

      dispatch(
        showToast({
          message: response.data.message,
          variant: "success",
        })
      );

      // Reset bulk state
      setSelectedContactKeys([])
      setBulkSelectedTags([]);
      setBulkNewTags([]);

      // onClose?.();
    } catch (error) {
      dispatch(
        showToast({
          message: "Failed to assign tags",
          variant: "danger",
        })
      );
      console.error(error);
    } finally {
      // setBulkIsLoading(false);
    }
  };

  useEffect(() => {
    if (!tags?.length) return;

    const formattedTags = tags
      .filter((t) => t.tag && t.emoji)
      .map((t) => ({
        value: t.tag,
        label: `${t.emoji} ${t.tag}`,
        emoji: t.emoji,
      }));

    setBulkAllTags(formattedTags);
  }, [tags]);









  const handleCustomerEditClick = (record) => {
    setSelectedCustomer(record);
  };
  const currentDateAndTime = new Date();
  const currentDate = currentDateAndTime.toLocaleDateString();
  const currentTime = currentDateAndTime.toLocaleTimeString();

  const handleContactStatus = async (rowKey, value) => {

    // Update local state immediately for UI feedback
    setStatusContact((prevState) => ({
      ...prevState,
      [rowKey]: value,
    }));

    // Call API to update status
    await handleStatusChange(rowKey, value);
  };

  useEffect(() => {
    // Initialize status from API data
    if (contacts.length > 0) {
      const initialStatuses = contacts.reduce((acc, contact) => {
        const contactId = contact.contact_id || contact._id;
        acc[contactId] = contact.status || "New";
        return acc;
      }, {});
      setStatusContact(initialStatuses);
    }
  }, [contacts]);

  // Fetch contacts from Redux cache or API
  const fetchContacts = async () => {
    const params = {
      page: currentPage,
      limit: pageLimit,
      search: searchQuery,
      status: selectedContactStatus,
      isFavourite: selectedIsFavourite,
      agentId: selectedAgents,
      tag: filterTags
    };

    // Dispatch Redux action to fetch with cache (pagination is stored in Redux)
    await dispatch(fetchContactsWithCache(params));
  };
  useEffect(() => {
    const fetchAgents = async () => {
      // setLoading(true);
      try {
        const response = await api.get("/admin/user/getAgent");
        if (response.data.status === "success") {
          setAgents(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
        dispatch(
          showToast({
            message: "Failed to fetch agents",
            variant: "danger",
          })
        );
      }
      // finally {
      //   setLoading(false);
      // }
    };



    if (userProfile.role === "companyAdmin") {
      fetchAgents()
    }




  }, [])


  const toggleAgent = (agentId) => {
    setSelectedAgents((prev) =>
      prev.includes(agentId)
        ? prev.filter((id) => id !== agentId) // remove if already selected
        : [...prev, agentId] // add if not selected
    );
  };
  const toggleTag = (tagId) => {
    setFilterTags((prev) =>
      prev.includes(tagId)
        ? prev.filter((id) => id !== tagId) // remove if already selected
        : [...prev, tagId] // add if not selected
    );
  };
  // Handle offcanvas contact update - clear cache and update locally
  const handleOffcanvasContactUpdate = async (contact_id, updatedData) => {
    dispatch(clearContactsCache());
    await fetchContacts();
  };

  // Fetch contacts on component mount and when dependencies change
  useEffect(() => {
    // Debounce search to avoid too many API calls
    const debounceTimer = setTimeout(
      () => {
        fetchContacts();
      },
      searchQuery ? 500 : 0
    ); // 500ms delay for search, immediate for other changes

    return () => clearTimeout(debounceTimer);
  }, [
    currentPage,
    pageLimit,
    searchQuery,
    selectedContactStatus,
    selectedIsFavourite,
    selectedAgents,
    filterTags
  ]);

  const handlePhoneClick = (phone) => {
    const assigned = userProfile?.assignedExtensions || [];
    const useModal = userProfile?.askBeforeDialing && assigned.length > 1;
    if (useModal) {
      setCallerModalTarget({ phone });
      return;
    }
    dispatch(setCallerAndNumber({
      phoneNumber:  phone,
      callerNumber: userProfile?.defaultCallerNumber || null,
    }));
  };

  // Handle status change
  const handleStatusChange = async (contact_id, newStatus, note = "") => {
    try {
      // If status changed to "interested", contact becomes a lead and removed from list

      // For other status changes, optimistically update the cache
      dispatch(
        updateContactInCache({ contact_id, updates: { status: newStatus } })
      );

      const response = await changeContactStatus({
        contact_id,
        newStatus,
        note,
        category: "lead",
      });

      if (response.status === "success") {
        // Clear contact details cache so it refetches on next visit
        dispatch(clearContactDetailsCache(contact_id));

        dispatch(
          showToast({
            message: response.message,
            type: "success",
          })
        );
      } else {
        // If API fails, revert by refetching
        await fetchContacts();
      }
    } catch (error) {
      console.error("Error changing status:", error);
      // Revert optimistic update by refetching
      await fetchContacts();
      dispatch(
        showToast({
          message: "Failed to update status",
          type: "error",
        })
      );
    }
  };

  // Handle delete contact
  const handleDeleteContact = async (e) => {
    e?.preventDefault();


    if (!contactToDelete) {
      return;
    }

    try {
      const response = await deleteContactOrLead(contactToDelete, "lead");

      if (response.status === "success") {
        dispatch(
          showToast({
            message: response.message,
            type: "success",
          })
        );

        // Close modal
        const closeButton = document.querySelector(
          '#delete_contact [data-bs-dismiss="modal"]'
        );
        if (closeButton) {
          closeButton.click();
        }

        // Clear cache and refresh contacts list
        dispatch(clearContactsCache());
        dispatch(setCurrentPage(1));
        fetchContacts();
        setContactToDelete(null);
      }
    } catch (error) {
      console.error("Error deleting contact:", error);
      dispatch(
        showToast({
          message: error.response?.data?.message || "Failed to delete contact",
          type: "error",
        })
      );
    }
  };

  const dealsopen = [
    { value: "choose", label: "Choose" },
    { value: "collins", label: "Collins" },
    { value: "konopelski", label: "Konopelski" },
    { value: "adams", label: "Adams" },
    { value: "schumm", label: "Schumm" },
    { value: "wisozk", label: "Wisozk" },
  ];
  const activities = [
    { value: "choose", label: "Choose" },
    { value: "phoneCalls", label: "Phone Calls" },
    { value: "socialMedia", label: "Social Media" },
    { value: "referralSites", label: "Referral Sites" },
    { value: "webAnalytics", label: "Web Analytics" },
    { value: "previousPurchases", label: "Previous Purchases" },
  ];
  const industries = [
    { value: "choose", label: "Choose" },
    { value: "Retail Industry", label: "Retail Industry" },
    { value: "Banking", label: "Banking" },
    { value: "Hotels", label: "Hotels" },
    { value: "Financial Services", label: "Financial Services" },
    { value: "Insurance", label: "Insurance" },
  ];
  const contactPersonsWithDetails = [
    {
      name: "Collins Robertson",
      contact_number: "1234567890",
      contact_mail: "abc@google.com",
      date_created: "15 Sept 2024",
      occupation: "General Manager",
      company_name: "Google",
    },
    {
      name: "Konopelski",
      contact_number: "1234567890",
      contact_mail: "abc@google.com",
      date_created: "15 Sept 2024",
      occupation: "Care Taker",
      company_name: "Meta",
    },
    {
      name: "Adams",
      contact_number: "1234567890",
      contact_mail: "abc@google.com",
      date_created: "15 Sept 2024",
      occupation: "Network Engineer",
      company_name: "Netflix",
    },
    {
      name: "Schumm",
      contact_number: "1234567890",
      contact_mail: "abc@google.com",
      date_created: "15 Sept 2024",
      occupation: "Developer",
      company_name: "Microsoft",
    },
    {
      name: "Wisozk",
      contact_number: "1234567890",
      contact_mail: "abc@google.com",
      date_created: "15 Sept 2024",
      occupation: "Sales Executive",
      company_name: "Oracle",
    },
  ];
  const languages = [
    { value: "Choose", label: "Choose" },
    { value: "English", label: "English" },
    { value: "Arabic", label: "Arabic" },
    { value: "Chinese", label: "Chinese" },
    { value: "Hindi", label: "Hindi" },
  ];
  const countries = [
    { value: "Choose", label: "Choose" },
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "France", label: "France" },
    { value: "UAE", label: "UAE" },
  ];

  const all_companies = [
    ...new Set(
      contactData
        .map((contact) => contact.customer_company)
        .filter((company) => company !== "") // Filter out empty companies
    ),
  ].map((company) => ({ label: company, value: company }));

  const exportPDF = () => {
    const doc = new jsPDF();

    const filteredColumns = columns.filter(
      (col) =>
        columnVisibility[col.title] &&
        col.title !== "Action" &&
        col.title !== "Contact"
    );

    const headers = filteredColumns.map((col) => col.title);
    const data = filteredContactData.map((row) =>
      filteredColumns.map((col) => row[col.dataIndex] || "")
    );

    const pageWidth = doc.internal.pageSize.getWidth();
    const titleText = "Contacts Report";
    const titleWidth = doc.getTextWidth(titleText);
    const titleX = (pageWidth - titleWidth) / 2;

    doc.setFontSize(15);
    doc.text(titleText, titleX, 20);

    doc.setFontSize(10);
    doc.text(`Exported on: ${currentDate} at ${currentTime}`, 15, 35);

    autoTable(doc, {
      startY: 40,
      head: [headers],
      body: data,
    });

    doc.save("Contacts_report.pdf");
  };
  const handleRadioSelect = (option) => {
    setSelectedOption(option); // Update the selected option
  };
  const exportExcel = () => {
    const wb = utils.book_new();
    const filteredColumns = columns.filter(
      (col) =>
        columnVisibility[col.title] &&
        col.title !== "Action" &&
        col.title !== "Contact"
    );
    const wsData = [
      [`Exported on: ${currentDate} at ${currentTime}`],
      [],
      filteredColumns.map((col) => col.title),
      ...filteredContactData.map((row) =>
        filteredColumns.map((col) => row[col.dataIndex] || "")
      ),
    ];

    const ws = utils.aoa_to_sheet(wsData);

    utils.book_append_sheet(wb, ws, "Contacts");

    writeFile(wb, "Contacts_report.xlsx");
  };

  //   const contactPersons = [...new Set(contactPersonsWithDetails.map((contactPerson) => contactPerson.name))]

  useEffect(() => {
    if (selectedContact?.tags) {

      const formattedTags = selectedContact.tags.map((tag) => ({
        value: tag.tag,
        label: `${tag.emoji} ${tag.tag}`,
        emoji: tag.emoji,
      }));
      setSelectedTags(formattedTags);
      setPreviousTags(formattedTags);
    }
  }, [selectedContact]);
  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text, record, index) => (
        <div
          className={`set-star rating-select ${record.isFavourite ? "filled" : ""
            }`}
          onClick={() => handleStarToggle(index)}
          key={index}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },

    {
      title: "Name",
      dataIndex: "customer_name",
      onHeaderCell: () => ({
    style: { minWidth: 100,maxWidth:200 }, // 👈 set your minimum width here
  }),

      onCell: () => ({
        className: "hoverable-cell",
        style: { minWidth: 100,maxWidth:200 }, // 👈 set your minimum width here
      }),
      render: (text, record, index) => (
        <div className="cell-content justify-content-between">
          <Link
            className="customer-name"
            to={
              userProfile.role === "user"
                ? route.agentLeadsDetails
                : route.leadsDetails
            }
            state={{ record }}
            style={{ color: "#2c5cc5", fontWeight: 700 }}
          >
            {text || "N/A"}
          </Link>
          {/* Icons that will be shown on hover */}
          <div className="icons">
            <div className="action-icons d-flex justify-content-center">
              {record.phone && (
                <a
                  onClick={() => {
                    if (!userProfile?.extensionStatus && !(userProfile?.assignedExtensions?.length > 0)) {
                      dispatch(
                        showToast({
                          message: "Extension is disabled. Kindly contact administrator",
                          variant: "danger",
                        })
                      );
                      return
                    }

                    dispatch(setActiveContact(record));
                    handlePhoneClick(record.phone);
                  }}
                  className="action-icon me-3"
                  title="Call"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ti ti-phone" />
                </a>
              )}
              {record.phone && (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#show_whatsapp_templates"
                  className="link-purple fw-medium action-icon"
                  onClick={() => {


                    if (!userProfile?.accounts?.whatsapp?.isConnected) {
                      dispatch(
                        showToast({
                          message: "WABA account is not configured. Please connect your WABA account",
                          variant: "danger",
                        })
                      );
                      return
                    }


                    dispatch(setActiveContact(record));
                  }}
                  title="WhatsApp"
                // target="_blank"
                >
                  <i className="fa-brands fa-whatsapp me-3"></i>
                </Link>
              )}
              {record.email && (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#show_email_templates"
                  className="link-purple fw-medium action-icon"
                  onClick={() => {
                    dispatch(setActiveContact(record));
                  }}
                  title="Email"
                >
                  <MdMail />
                </Link>
              )}
            </div>
          </div>
          <div>
            <Link
              to=""
              className="action-icon"
              data-bs-toggle="dropdown"
              aria-expanded="true"
            >
              <HiEllipsisVertical />
            </Link>
            <div
              className="dropdown-menu dropdown-menu-right"
              style={{
                position: "absolute",
                inset: "0px auto auto 0px",
                margin: "0px",
                transform: "translate3d(-99.3333px, 35.3333px, 0px)",
              }}
              data-popper-placement="bottom-start"
            >
              <Link
                className="dropdown-item edit-popup"
                to=""
                data-bs-toggle="offcanvas"
                data-bs-target="#customer_offcanvas"
                onClick={() => {
                  handleCustomerEditClick(record);
                }}
              >
                <i className="ti ti-edit text-blue"></i> Edit
              </Link>
              <Link
                className="dropdown-item edit-popup"
                to={
              userProfile.role === "user"
                ? route.agentLeadsDetails
                : route.leadsDetails
            }
            state={{ record }}
              >
                <i className="ti ti-eye text-blue"></i> View
              </Link>
              <Link
                className="dropdown-item"
                to=""
                data-bs-toggle="modal"
                data-bs-target="#delete_contact"
                onClick={() => setContactToDelete(record.key)}
              >
                <i className="ti ti-trash text-danger"></i> Delete
              </Link>
            </div>
          </div>
        </div>
      ),
      sorter: (a, b) => a.customer_name.localeCompare(b.customer_name),
    },

    {
      title: "Company",
      dataIndex: "customer_company",
      width: 200,
      render: (text, record) => {
        return (
          <Link
            className="customer-name"
            to={
              userProfile.role === "user"
                ? route.agentLeadsDetails
                : route.leadsDetails
            }
            state={{ record }}
            style={{ color: "#2c5cc5", fontWeight: 700 }}
          >
            {text || "N/A"}
          </Link>
        );
      },
      sorter: (a, b) => a.customer_company.localeCompare(b.customer_company),
    },

    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      onCell: (record) => ({
        onMouseEnter: () => {
          const editIcon = document.querySelector(
            `.edit-icon-${record.key}-phone`
          );
          if (editIcon) editIcon.style.visibility = "visible";
        },
        onMouseLeave: () => {
          const editIcon = document.querySelector(
            `.edit-icon-${record.key}-phone`
          );
          if (editIcon) editIcon.style.visibility = "hidden";
        },
      }),
      render: (text, record) => (
        <>
          <EditCell
            fieldName="Phone"
            fieldValue={text}
            recordKey={record.key}
            columnKey="phone"
            routeLink="#"
            textColor="#2c5cc5"
            isActive={
              activeCell?.rowKey === record.key &&
              activeCell?.columnKey === "phone"
            }
            onSave={(key, value) => handleSaveField(key, "phone", value)}
            onEditClick={() => handleEditClick(record.key, "phone")}
            onClose={handleClose}
          />
        </>
      ),
      sorter: (a, b) => a.phone.localeCompare(b.phone),
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      onCell: (record) => ({
        onMouseEnter: () => {
          const editIcon = document.querySelector(
            `.edit-icon-${record.key}-email`
          );
          if (editIcon) editIcon.style.visibility = "visible";
        },
        onMouseLeave: () => {
          const editIcon = document.querySelector(
            `.edit-icon-${record.key}-email`
          );
          if (editIcon) editIcon.style.visibility = "hidden";
        },
      }),
      render: (text, record) => (
        <>
          <EditCell
            fieldName="Email"
            fieldValue={text}
            recordKey={record.key}
            columnKey="email"
            routeLink="#"
            textColor="#2c5cc5"
            isActive={
              activeCell?.rowKey === record.key &&
              activeCell?.columnKey === "email"
            }
            onSave={(key, value) => handleSaveField(key, "email", value)}
            onEditClick={() => handleEditClick(record.key, "email")}
            onClose={handleClose}
          />
        </>
      ),
      sorter: (a, b) => a.email.localeCompare(b.email),
    },

    {
      title: "Designation",
      dataIndex: "customer_occupation",
      render: (text, record) => (
        <span style={{ color: "#333" }}>{text || "N/A"}</span>
      ),
      sorter: (a, b) =>
        a.customer_occupation.localeCompare(b.customer_occupation),
    },

  




    {
      title: "Groups",
      dataIndex: "tags",
      width: 135,
      render: (tags, record) => {

        const isActiveContact =
          activeGroupEdit?.contactId === record?.key;
        const isEditingThisTag =
          isActiveContact && activeGroupEdit?.tagIndex === 0;

        if (tags?.length === 0) {
          return (
            <div
              style={{ cursor: "pointer", color: "#92a2b1", fontWeight: 600 }}
              onClick={() => {
                const isAlreadyOpen =
                  activeGroupEdit?.contactId === record?.key &&
                  activeGroupEdit?.tagIndex === 0;

                if (!isAlreadyOpen) {
                  dispatch(setActiveContact(record));
                  setActiveGroupEdit({
                    contactId: record.key,
                    tagIndex: 0,
                  });
                }
              }}
            >
              + Click to add
              {isEditingThisTag && (
                <div
                  className="popup position-absolute"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 100,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    padding: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    width: "228px",
                    marginTop: "5px",
                  }}
                >
                  <div className="mb-3">
                    <label className="col-form-label">Groups</label>
                    <CreatableSelect
                      classNamePrefix="react-select"
                      options={allTags}
                      value={selectedTags}
                      onChange={(newValue) => handleUserTags(newValue)}
                      onCreateOption={handleCreateTag}
                      className="js-example-placeholder-multiple select2 js-states"
                      isMulti={true}
                      placeholder="Add Tags"
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={() => {
                        dispatch(setSelectedContact(null));
                        setActiveGroupEdit(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        saveCellTags();
                        setActiveGroupEdit(null);
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        }

        return (
          <div className="d-flex tagScrollbar"
            style={{ maxWidth: 150 }}
          >
            {tags?.map((tag, index) => {
              // const isHovered = groupHoveredIndex === index;
              const isEditingThisTag =
                isActiveContact && activeGroupEdit?.tagIndex === index;

              return (
                <div
                  key={index}
                  className="py-1 px-2 d-flex flex-wrap me-2"
                  style={{
                    background: "#dff0ff",
                    borderRadius: 5,
                    cursor: "pointer",
                    marginBottom: "5px",
                  }}
                  // onMouseEnter={() => setGroupHoveredIndex(index)}
                  // onMouseLeave={() => setGroupHoveredIndex(null)}
                  onClick={() => {
                    const isAlreadyOpen =
                      activeGroupEdit?.contactId === record?.key &&
                      activeGroupEdit?.tagIndex === index;

                    if (!isAlreadyOpen) {

                      dispatch(setActiveContact(record));
                      setActiveGroupEdit({
                        contactId: record?.key,
                        tagIndex: index,
                      });
                    }
                  }}
                >
                  <div className="d-flex align-items-centerflex-wrap">
                    {/* <img
                      src="/assets/img/icons/tagIcon.svg"
                      className="me-1"
                      style={{ color: "#264966", width: 15 }}
                    /> */}
                    <div style={{ color: "#264966", fontSize: 14 }}>
                      {tag.emoji} {tag.tag}
                    </div>
                  </div>

                  {isEditingThisTag && (
                    <div
                      className="popup position-absolute"
                      style={{
                        top: "100%",
                        left: 0,
                        zIndex: 100,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        width: "228px",
                      }}
                    >
                      <div className="mb-3">
                        <label className="col-form-label">Groups</label>

                        <CreatableSelect
                          classNamePrefix="react-select"
                          options={allTags}
                          value={selectedTags}
                          onChange={(newValue) => handleUserTags(newValue)}
                          onCreateOption={handleCreateTag}
                          className="js-example-placeholder-multiple select2 js-states"
                          isMulti={true}
                          placeholder="Add Tags"
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light me-2"
                          onClick={() => {
                            dispatch(setSelectedContact(null));
                            setActiveGroupEdit(null);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            saveCellTags();
                            setActiveGroupEdit(null);
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },
  {
      title: "Contact Status",
      dataIndex: "status",
      render: (text, record) => (
        // <div>
        //   <div className="dropdown d-inline-block">
        //     <Link
        //       to=""
        //       className="py-1 border-0"
        //       style={{
        //         boxShadow: "none",
        //         fontSize: "12px",
        //         padding: "4px 8px 4px 4px",
        //         color:
        //           statusContact[record.key] === "Active"
        //             ? "#00795b"
        //             : statusContact[record.key] === "dummy"
        //               ? "#264966"
        //               : statusContact[record.key] === "dummy2"
        //                 ? "#d58c08"
        //                 : statusContact[record.key] === "Inactive"
        //                   ? "#ff1616c7"
        //                   : "#000000c7",
        //         backgroundColor:
        //           statusContact[record.key] === "Active"
        //             ? "#e0f5f1"
        //             : statusContact[record.key] === "dummy3"
        //               ? "#dff0ff"
        //               : statusContact[record.key] === "dummy4"
        //                 ? "#ffd9947a"
        //                 : statusContact[record.key] === "Inactive"
        //                   ? "#c169692b"
        //                   : "#62626273",
        //       }}
        //       data-bs-toggle="dropdown"
        //       aria-expanded="false"
        //     >
        //       <MdDoubleArrow />
        //       {statusContact[record.key] || "Select Status"}
        //     </Link>
        //     <div className="dropdown-menu dropdown-menu-right">
        //       {contactStatus.map((contactStatus, index) => (
        //         <Link
        //           className="dropdown-item"
        //           to=""
        //           key={index}
        //           onClick={() => handleContactStatus(record.key, contactStatus.value)}
        //         >
        //           {contactStatus.label}
        //         </Link>
        //       ))}
        //     </div>
        //   </div>
        // </div>
        <div>
          <div className="dropdown d-inline-block">
            <Link
              to="#"
              className="py-1 border-0"
              style={{
                boxShadow: "none",
                fontSize: "12px",
                padding: "4px 8px",
                borderRadius: "12px",
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                ...getStatusStyle(statusContact[record.key]),
              }}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <MdDoubleArrow />
              {contactStatusOptions.find(
                (cs) => cs.value === statusContact[record.key]
              )?.label || "Select Status"}
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              {contactStatusOptions.map((contactstatus, index) => (
                <Link
                  className="dropdown-item"
                  to="#"
                  key={index}
                  onClick={() =>
                    handleContactStatus(record.key, contactstatus.value)
                  }
                  style={{
                    backgroundColor: contactstatus.color,
                    marginBottom: "2px",
                  }}
                >
                  {contactstatus.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ),
      sorter: (a, b) => a.status.localeCompare(b.status),
    },








    ...(userProfile.role === "companyAdmin"
      ? [
        {
          title: "Created By",
          dataIndex: "agent", // assume each record has an `agent` object
          key: "agentName",
          render: (text, record) => {
            // record.agent should have firstname and lastname
            return (
              <div className="cell-content">
                {record._originalData?.agentName || "N.A"}
              </div>
            );
          },
          // sorter: (a, b) => {
          //   const nameA = (a.agent?.firstname + " " + a.agent?.lastname).toLowerCase();
          //   const nameB = (b.agent?.firstname + " " + b.agent?.lastname).toLowerCase();
          //   return nameA.localeCompare(nameB);
          // },
        },
      ]
      : []),
    ...(userProfile.role === "companyAdmin"
      ? [
        {
          title: "Assigned to",
          dataIndex: "agent", // assume each record has an `agent` object
          key: "assignedNames",
          render: (text, record) => {
            // record.agent should have firstname and lastname
            return (
              <div className="cell-content">
                
                {record._originalData?.assignedNames?.length
  ? record._originalData.assignedNames.join(", ")
  : "-"}
              </div>
            );
          },
          // sorter: (a, b) => {
          //   const nameA = (a.agent?.firstname + " " + a.agent?.lastname).toLowerCase();
          //   const nameB = (b.agent?.firstname + " " + b.agent?.lastname).toLowerCase();
          //   return nameA.localeCompare(nameB);
          // },
        },
      ]
      : []),
  ];
  const resetFilters = () => {
    dispatch(setSelectedContactStatus([]));
    dispatch(setSelectedIsFavourite(null));
    dispatch(setSearchQuery(""));
    dispatch(setCurrentPage(1));
    dispatch(setPageLimit(10));
    // Clear Redux cache
    dispatch(clearContactsCache());
    setFilterTags([])
    setIsFilterOpen(false);
  };

  const visibleColumns = columns.filter(
    (column) => columnVisibility[column.title]
  );

  // Transform API data to table format
  const transformContactData = (apiContacts) => {
    return apiContacts.map((contact, index) => {
      const contactId = contact.contact_id || contact._id;

      // Get first phone number
      const firstPhone =
        contact.phoneNumbers && contact.phoneNumbers.length > 0
          ? `+${contact.phoneNumbers[0].countryCode} ${contact.phoneNumbers[0].number}`
          : "";

      // Get first email
      const firstEmail =
        contact.emailAddresses && contact.emailAddresses.length > 0
          ? contact.emailAddresses[0]
          : "";

      const tagText =
        contact.tags && contact.tags.length > 0 ? contact.tags[0].tag : "";

      return {
        id: contactId,
        key: contactId,
        firstname: contact.firstname || "",
        lastname: contact.lastname || "",
        designation: contact.designation || "",
        customer_name: `${contact.firstname || ""} ${contact.lastname || ""
          }`.trim(),
        customer_image:
          contact.contactImageURL || "assets/img/profiles/avatar-default.jpg",
        phone: firstPhone,
        email: firstEmail,
        allPhones: contact.phoneNumbers || [],
        allEmails: contact.emailAddresses || [],
        customer_company: contact.company || "",
        customer_tag: tagText,
        customer_occupation: contact.designation || "",
        website: contact.website || "",
        location: "",
        rating: "0",
        owner: contact.owner || "",
        owner_image: "assets/img/profiles/avatar-14.jpg",
        status: contact.status || "New",
        isFavourite: contact.isFavourite || false,
        isVerified: contact.isVerified || false,
        tags: contact.tags || [],
        dateCreated: contact.createdAt
          ? new Date(contact.createdAt).toLocaleDateString()
          : "",
        // Store original data for editing
        _originalData: contact,
      };
    });
  };

  const data = transformContactData(contacts);

  // Handle row selection from table
  const handleRowSelectionChange = (selectedKeys, selectedRows) => {
    setSelectedContactKeys(selectedKeys);
    setSelectedContactRows(selectedRows);
  };

  // Handle batch delete
  const handleBatchDelete = async () => {
    try {
      // Extract contact IDs from selected rows
      const contactIds = selectedContactRows.map(
        (row) => row._originalData._id
      );

      const response = await batchDeleteContacts(contactIds, "lead");

      if (response.status === "success") {
        dispatch(
          showToast({
            message: response.message,
            type: "success",
          })
        );

        // Clear selection
        setSelectedContactKeys([]);
        setSelectedContactRows([]);
        setShowBatchDeleteModal(false);

        // Clear cache and refresh contact list
        dispatch(clearContactsCache());
        dispatch(setCurrentPage(1));

        fetchContacts();
      }
    } catch (error) {
      dispatch(
        showToast({
          message: error.response?.data?.message || "Error deleting contacts",
          type: "error",
        })
      );
    }
  };

  const handleStarToggle = async (index) => {
    const contact = data[index];
    if (contact && contact._originalData) {
      const currentFavoriteStatus = contact.isFavourite;
      const newFavoriteStatus = !currentFavoriteStatus;

      try {
        // Optimistically update the cache first
        dispatch(
          updateContactInCache({
            contact_id: contact._originalData._id,
            updates: { isFavourite: newFavoriteStatus },
          })
        );

        // Call API to toggle favorite
        const response = await toggleContactFavorite(
          contact._originalData._id,
          newFavoriteStatus,
          "lead"
        );

        if (response.status === "success") {
          // Clear contact details cache so it refetches on next visit
          dispatch(clearContactDetailsCache(contact._originalData._id));

          dispatch(
            showToast({
              message: newFavoriteStatus
                ? "Contact added to favorites"
                : "Contact removed from favorites",
              type: "success",
            })
          );
        } else {
          // If API fails, revert by refetching
          await fetchContacts();
          dispatch(
            showToast({
              message: "Failed to update favorite status",
              type: "error",
            })
          );
        }
      } catch (error) {
        // Revert optimistic update by refetching
        await fetchContacts();
        dispatch(
          showToast({
            message:
              error.response?.data?.message || "Error updating favorite status",
            type: "error",
          })
        );
      }
    }
  };

  const filteredContactData = data;
  const handleToggleColumnVisibility = (columnTitle) => {
    setColumnVisibility((prevVisibility) => ({
      ...prevVisibility,
      [columnTitle]: !prevVisibility[columnTitle],
    }));
  };

  const filterContactStatus = (contactStatus) => {
    dispatch(
      setSelectedContactStatus(
        selectedContactStatus.includes(contactStatus)
          ? selectedContactStatus.filter((status) => status !== contactStatus)
          : [...selectedContactStatus, contactStatus]
      )
    );
  };

  const handleDownload = () => {
    const data = [
      [
        "firstname",
        "lastname",
        "company",
        "designation",
        "emailaddresses",
        "phonenumbers",
        // "instagram",
        // "twitter",
        // "linkedin",
        // "facebook",
        // "telegram",
        "status",
      ],
      [
        "John",
        "Doe",
        "TechCorp",
        "Software Engineer",
        "john.doe@example.com",
        "+971 50 1234567",
        // "https://instagram.com/johndoe",
        // "https://twitter.com/johndoe",
        // "https://linkedin.com/in/johndoe",
        // "https://facebook.com/johndoe",
        // "https://t.me/johndoe",
        "interested",
      ],
      [
        "Jane",
        "Smith",
        "DesignHub",
        "Product Designer",
        "jane.smith@example.com",
        "+971 50 9876543",
        // "https://instagram.com/janesmith",
        // "https://twitter.com/janesmith",
        // "https://linkedin.com/in/janesmith",
        // "https://facebook.com/janesmith",
        // "https://t.me/janesmith",
        "called",
      ],
      [
        "Alice",
        "Johnson",
        "FinTech Ltd",
        "Data Analyst",
        "alice.johnson@example.com",
        "+971 55 1122334",
        // "https://instagram.com/alicejohnson",
        // "https://twitter.com/alicejohnson",
        // "https://linkedin.com/in/alicejohnson",
        // "https://facebook.com/alicejohnson",
        // "https://t.me/alicejohnson",
        "notInterested",
      ],
    ];

    // Convert data to CSV format
    const csvContent =
      "data:text/csv;charset=utf-8," +
      data.map((row) => row.join(",")).join("\n");

    // Create a Blob and download it as an Excel file
    const downloadLink = document.createElement("a");
    downloadLink.href = encodeURI(csvContent);
    downloadLink.download = "sample.csv";

    // Simulate a click to trigger the download
    downloadLink.click();
  };

  // Helper function to handle import with country code
  //   const handleImportWithCountryCode = async (provider, countryCode, selectedTags) => {

  //     try {
  //       const response = await api.get(`/fetch-${provider}-contacts`, {
  //         params: { defaultCountryCode: countryCode,
  // selectedTags
  //          },
  //       });

  //       if (response.data.status === "success" && response.data.url) {
  //         const width = 500;
  //         const height = 600;
  //         const left = window.screenX + (window.outerWidth - width) / 2;
  //         const top = window.screenY + (window.outerHeight - height) / 2;

  //         const messageHandler = (event) => {

  //           const data = event.data;
  //           if (data?.status === "success") {
  //             setImportModal(false);
  //             setTimeout(() => {
  //               window.location.reload();
  //             }, 2000);
  //             dispatch(
  //               showToast({
  //                 message: "Contacts fetched successfully",
  //                 variant: "success",
  //               })
  //             );

  //             window.removeEventListener("message", messageHandler);
  //             popup?.close();
  //           }
  //         };
  //         window.addEventListener("message", messageHandler);

  //         const popup = window.open(
  //           response.data.url,
  //           "_blank",
  //           `width=${width},height=${height},left=${left},top=${top}`
  //         );
  //         if (!popup) {
  //           console.error("Popup blocked");
  //         }
  //       }
  //     } catch (error) {
  //       console.error(`${provider} Sign-In initiation failed`, error);
  //     }
  //   };


  const handleImportWithCountryCode = async (
    provider,
    countryCode,
    selectedTags,
    selectedFile,
    newTags
  ) => {
    try {

      if (newTags?.length > 0) {
        const addNewTagResponse = await dispatch(addTag(newTags)).unwrap();
      }



      const selectedTagsFormatted = selectedTags?.map((tag) => ({
        tag: tag.value,
        emoji: tag.emoji,
      }));



      // ================================
      // ✅ CSV / EXCEL FLOW
      // ================================
      if (provider === "csvExcel") {
        if (!selectedFile) {
          dispatch(
            showToast({
              message: "Please select a file to import",
              type: "error",
            })
          );
          return;
        }

        const reader = new FileReader();

        reader.onload = async (event) => {
          try {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const contacts = XLSX.utils.sheet_to_json(sheet);

            const response = await dispatch(
              saveBulkContacts({
                contacts,
                defaultCountryCode: countryCode,
                tags: selectedTagsFormatted,
              })
            ).unwrap();

            if (response.status === "success") {
              dispatch(clearContactsCache());
              await fetchContacts();
              setImportModal(false);

              dispatch(
                showToast({
                  message: "Contacts imported successfully",
                  type: "success",
                })
              );
            }
          } catch (error) {
            console.error("Error processing file:", error);
            dispatch(
              showToast({
                message:
                  error.message ||
                  "Failed to import contacts. Please check your file format.",
                type: "error",
              })
            );
          }
        };

        reader.onerror = () => {
          dispatch(
            showToast({
              message: "Failed to read file. Please try again.",
              type: "error",
            })
          );
        };

        reader.readAsArrayBuffer(selectedFile);

        return; // ⛔ IMPORTANT: stop here for csvExcel
      }

      // ================================
      // ✅ GOOGLE / ZOHO / HUBSPOT FLOW
      // ================================
      const payload = {
        defaultCountryCode: countryCode,
        tags: selectedTagsFormatted,
        category: "lead",
      };

      const response = await api.get(`/fetch-${provider}-contacts`, {
        params: payload,
      });

      if (response.data.status === "success" && response.data.url) {
        const width = 500;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;

        const messageHandler = (event) => {
          const data = event.data;

          if (data?.status === "success") {
            setImportModal(false);
            setTimeout(() => window.location.reload(), 2000);

            dispatch(
              showToast({
                message: "Contacts fetched successfully",
                variant: "success",
              })
            );

            window.removeEventListener("message", messageHandler);
            popup?.close();
          }
        };

        window.addEventListener("message", messageHandler);

        const popup = window.open(
          response.data.url,
          "_blank",
          `width=${width},height=${height},left=${left},top=${top}`
        );

        if (!popup) {
          console.error("Popup blocked");
        }
      }
    } catch (error) {
      console.error(`${provider} Sign-In initiation failed`, error);
    }
  };
  const Step1 = () => {
    const { previousStep, nextStep } = useWizard();

    return (
      <>
        <h2 className="uploadHeading mb-3">
          Select a way to import your contacts
        </h2>
        <p className="uploadSubHeading">
          Contacts (or 'leads') are people you engage with
        </p>

        <div className="d-md-flex justify-content-center">
          <div
            className={`importMenu  ${selectedOption === "csvExcel" ? "selected" : ""
              }`}
            onClick={() => handleRadioSelect("csvExcel")}
          >
            <div className="importIcons">
              <ImageWithBasePath
                src="assets/img/customIcons/excelLogo.png"
                alt="Excel Logo"
              />
            </div>
            <p className="importType">CSV or Excel</p>
          </div>
          <div
            className={`importMenu ${selectedOption === "google" ? "selected" : ""
              }`}
            onClick={() => handleRadioSelect("google")}
          >
            <div className="importIcons">
              <ImageWithBasePath
                src="assets/img/icons/googleLogo.png"
                alt="google Logo"
              />
            </div>
            <p className="importType">Google Contacts</p>
          </div>
        </div>
        <div className="d-md-flex justify-content-center mt-md-3">
          <div
            className={`importMenu ${selectedOption === "zoho" ? "selected" : ""
              }`}
            onClick={() => handleRadioSelect("zoho")}
          >
            <div
              style={{
                height: 40,
                marginRight: 15,
                justifyContent: "center",
                display: "flex",
              }}
            >
              <ImageWithBasePath
                src="assets/img/customIcons/zohoLogo.png"
                alt="Zoho Logo"
              />
            </div>
            <p className="importType">Zoho</p>
          </div>
          <div
            className={`importMenu ${selectedOption === "hubspot" ? "selected" : ""
              }`}
            onClick={() => handleRadioSelect("hubspot")}
          >
            <div className="importIcons">
              <ImageWithBasePath
                src="assets/img/icons/hubspotLogo.jpg"
                alt="Hubspot Logo"
              />
            </div>
            <p className="importType">Hubspot</p>
          </div>
        </div>
        <div className="wizardBtnContainer">
          {selectedOption && (
            <button
              className="nextStep btn btn-primary"
              onClick={async () => {
                // For Google, Zoho, and HubSpot, show country code prompt first
                if (["google", "zoho", "hubspot", "csvExcel"].includes(selectedOption)) {
                  setPendingImportProvider(selectedOption);
                  setShowCountryCodePrompt(true);
                }
                // else if (selectedOption === "csvExcel") {
                //   nextStep();
                // }
              }}
            >
              Next
            </button>
          )}
        </div>
      </>
    );
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    if (!file) return;
    setSelectedExcelFileName(file.name);
    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const contacts = XLSX.utils.sheet_to_json(sheet);
        setParsedExcelContacts(contacts)
        // const response = await dispatch(saveBulkContacts(contacts)).unwrap();

        // if (response.status == "success") {
        //   dispatch(clearContactsCache());
        //   await fetchContacts();
        //   setImportModal(false);
        // }
      } catch (error) {
        console.error("Error processing file:", error);
      }
    };

    reader.onerror = () => {
      dispatch(
        showToast({
          message: "Failed to read file. Please try again.",
          type: "error",
        })
      );
    };

    reader.readAsArrayBuffer(file);
  };
  const Step3 = () => {
    const { handleStep, previousStep, nextStep } = useWizard();

    return (
      <>
        {selectedOption === "csvExcel" && (
          <div>
            <h2 className="uploadHeading">Upload Your File</h2>
            <div className="uploadSectionContainer">
              <div className="uploadSectionInnerBox">
                <div className="uploadSectionImageBox">
                  <ImageWithBasePath
                    src="assets/img/customIcons/excelLogo.png"
                    className="uploadSectionImage"
                    alt="Excel Logo"
                  />
                </div>
                <div className="profile-upload d-block">
                  <div className="profile-upload-content">
                    <div className="mb-2">{selectedExcelFileName}</div>
                    <label className="profile-upload-btn">
                      <i className="ti ti-file-broken" /> Upload File
                      <input
                        type="file"
                        className="input-img"
                        onChange={handleFileChange}
                      />
                    </label>
                    <p>Only Excel file</p>
                  </div>
                </div>
                <p className="supportedFormat">
                  (Supported formats .xlsx; max file size 5 MB)
                </p>
                <p className="text-muted">
                  Download a{" "}
                  <span
                    onClick={handleDownload}
                    style={{ cursor: "pointer", color: "#2c5cc5" }}
                  >
                    sample CSV
                  </span>
                </p>
              </div>
            </div>
            <div className="wizardBtnContainer">
              <button
                className="btn btn-light previousStep me-3"
                onClick={() => previousStep()}
              >
                Go Back
              </button>
              <button
                className="btn btn-primary previousStep"
                onClick={() => setShowCountryCodePrompt(true)}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content h-100">
            <div className="row h-100">
              <div className="col-md-12">
                <div className="card h-100">
                  <div className="card-header">
                    {/* Desktop Layout - Single Row */}
                    <div className="contacts-header-desktop">
                      <div className="contacts-header-left-group">
                        <div className="page-header mb-0">
                          <h4 className="page-title mb-0">
                            Leads
                            <span className="count-title">
                              {pagination.totalItems}
                            </span>
                          </h4>
                        </div>
                      </div>

                      <div className="contacts-header-right-group">
                        {selectedContactKeys.length == 0 &&
                          <>
                            <div className="icon-form contacts-search-desktop">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Leads"
                                value={searchQuery}
                                onChange={(text) =>
                                  dispatch(setSearchQuery(text.target.value))
                                }
                              />
                            </div>

                            <button
                              className="btn btn-primary d-flex align-items-center contacts-refresh-btn"
                              onClick={async () => {
                                dispatch(clearContactsCache());
                                fetchContacts();
                              }}
                              disabled={loading}
                            >
                              <i
                                className={`ti ti-refresh fs-5 ${loading ? "ti-spin" : ""
                                  }`}
                              />
                            </button>

                            <div className="form-sorts dropdown">
                              {/* <Link
                                to=""
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                                className="contacts-filter-btn"
                              >
                                <i className="ti ti-filter-share" />
                                <span className="ms-1">Filter</span>
                              </Link> */}
                              <Link
                                to=""
                                className="contacts-filter-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsFilterOpen((prev) => !prev);
                                }}
                              >
                                <i className="ti ti-filter-share" />
                                <span className="ms-1">Filter</span>
                              </Link>
                              {/* <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3"> */}
                              <div className={`filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3 ${isFilterOpen ? "show" : ""}`}>
                                <div className="filter-set-view">
                                  <div className="filter-set-head">
                                    <h4>
                                      <i className="ti ti-filter-share" />
                                      Filter
                                    </h4>
                                  </div>
                                  <div className="accordion" id="accordionExample">
                                    <div className="filter-set-content">
                                      <div className="filter-set-content-head">
                                        <Link
                                          to=""
                                          className="collapsed"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#Status"
                                          aria-expanded="false"
                                          aria-controls="Status"
                                        >
                                          Contact Status
                                        </Link>
                                      </div>
                                      <div
                                        className="filter-set-contents accordion-collapse collapse"
                                        id="Status"
                                        data-bs-parent="#accordionExample"
                                      >
                                        <div className="filter-content-list">
                                          <ul>
                                            {contactStatusOptions.map(
                                              (contactStatus, index) => {
                                                return (
                                                  <li key={index}>
                                                    <div className="filter-checks">
                                                      <label className="checkboxs">
                                                        <input
                                                          type="checkbox"
                                                          checked={selectedContactStatus.includes(
                                                            contactStatus.value
                                                          )}
                                                          onChange={() =>
                                                            filterContactStatus(
                                                              contactStatus.value
                                                            )
                                                          }
                                                        />
                                                        <span className="checkmarks" />
                                                        <span />
                                                        {contactStatus.label}
                                                      </label>
                                                    </div>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="filter-set-content">
                                      <div className="filter-set-content-head">
                                        <Link
                                          to=""
                                          className="collapsed"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#groups"
                                          aria-expanded="false"
                                          aria-controls="groups"
                                        >
                                          Groups
                                        </Link>
                                      </div>

                                      <div
                                        className="filter-set-contents accordion-collapse collapse"
                                        id="groups"
                                        data-bs-parent="#accordionExample"
                                      >
                                        <div className="filter-content-list">
                                          <ul>
                                            {tags?.map((tag) => (
                                              <li key={tag.tag_id}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterTags.includes(tag.tag)}
                                                      onChange={() => toggleTag(tag.tag)}
                                                    />
                                                    <span className="checkmarks" />
                                                    {tag.tag}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}

                                          </ul>
                                        </div>
                                      </div>
                                    </div>

                                    {userProfile.role === "companyAdmin" && (
                                      <div className="filter-set-content">
                                        <div className="filter-set-content-head">
                                          <Link
                                            to=""
                                            className="collapsed"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#agent"
                                            aria-expanded="false"
                                            aria-controls="agent"
                                          >
                                            Agent
                                          </Link>
                                        </div>

                                        <div
                                          className="filter-set-contents accordion-collapse collapse"
                                          id="agent"
                                          data-bs-parent="#accordionExample"
                                        >
                                          <div className="filter-content-list">
                                            <ul>

                                              {/* ✅ SELF OPTION */}
                                              <li>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={selectedAgents.includes(userProfile.id)}
                                                      onChange={() => toggleAgent(userProfile.id)}
                                                    />
                                                    <span className="checkmarks" />
                                                    {userProfile.firstname}{" "}{userProfile.lastname}{" "}(Self) ({userProfile?.leadCount})
                                                  </label>
                                                </div>
                                              </li>

                                              {/* 🔹 AGENTS LIST */}
                                              {agents?.map((agent) => (
                                                <li key={agent._id}>
                                                  <div className="filter-checks">
                                                    <label className="checkboxs">
                                                      <input
                                                        type="checkbox"
                                                        checked={selectedAgents.includes(agent._id)}
                                                        onChange={() => toggleAgent(agent._id)}
                                                      />
                                                      <span className="checkmarks" />
                                                      {agent.firstname} {agent.lastname} ({agent?.leadCount})
                                                    </label>
                                                  </div>
                                                </li>
                                              ))}

                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    )}


                                    <div className="filter-set-content">
                                      <div className="filter-set-content-head">
                                        <Link
                                          to=""
                                          className="collapsed"
                                          data-bs-toggle="collapse"
                                          data-bs-target="#favourite"
                                          aria-expanded="false"
                                          aria-controls="favourite"
                                        >
                                          Favourites
                                        </Link>
                                      </div>
                                      <div
                                        className="filter-set-contents accordion-collapse collapse"
                                        id="favourite"
                                        data-bs-parent="#accordionExample"
                                      >
                                        <div className="filter-content-list">
                                          <ul>

                                            <li>
                                              <div className="filter-checks">
                                                <label className="checkboxs">
                                                  <input
                                                    type="checkbox"
                                                    name="favourite"
                                                    checked={
                                                      selectedIsFavourite === true
                                                    }
                                                    onChange={() =>
                                                      dispatch(
                                                        setSelectedIsFavourite(
                                                          selectedIsFavourite === true ? null : true
                                                        )
                                                      )
                                                    }
                                                  />
                                                  <span className="checkmarks" />
                                                  Favourites Only
                                                </label>
                                              </div>
                                            </li>

                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="filter-reset-btns">
                                    <div className="row">
                                      <div className="col-6">
                                        <Link
                                          to=""
                                          className="btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setIsFilterOpen(false);
                                          }}
                                        >
                                          OK
                                        </Link>
                                      </div>
                                      <div className="col-6">
                                        <Link
                                          to=""
                                          className="btn btn-primary"
                                          onClick={resetFilters}
                                        >
                                          Reset
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="dropdown">
                              <Link
                                to=""
                                className="btn bg-soft-purple text-purple contacts-columns-btn"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                              >
                                <i className="ti ti-columns-3 me-2" />
                                <span>Manage Columns</span>
                              </Link>
                              <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                                <div className="border-top pt-3">
                                  {columns.map((column, index) => {
                                    if (
                                      column.title === "Action" ||
                                      column.title === ""
                                    ) {
                                      return;
                                    }
                                    return (
                                      <div
                                        className="d-flex align-items-center justify-content-between mb-3"
                                        key={index}
                                      >
                                        <p className="mb-0 d-flex align-items-center">
                                          <i className="ti ti-grip-vertical me-2" />
                                          {column.title}
                                        </p>
                                        <div className="status-toggle">
                                          <input
                                            type="checkbox"
                                            id={column.title}
                                            className="check"
                                            checked={
                                              !!columnVisibility[column.title]
                                            }
                                            onChange={() =>
                                              handleToggleColumnVisibility(
                                                column.title
                                              )
                                            }
                                          />
                                          <label
                                            htmlFor={column.title}
                                            className="checktoggle"
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>

                            <div className="dropdown">
                              <Link
                                to=""
                                className="dropdown-toggle contacts-export-btn"
                                data-bs-toggle="dropdown"
                              >
                                <i className="ti ti-package-export me-2" />
                                <span>Import/Export</span>
                              </Link>
                              <div className="dropdown-menu dropdown-menu-end">
                                <ul className="mb-0">
                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() => setImportModal(true)}
                                    >
                                      <i className="fa-solid fa-file-arrow-up me-2 text-primary"></i>
                                      Import
                                    </button>
                                  </li>
                                  <li>
                                    <Link
                                      to=""
                                      className="dropdown-item"
                                      onClick={exportPDF}
                                    >
                                      <i className="ti ti-file-type-pdf text-danger me-1" />
                                      Export as PDF
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to=""
                                      className="dropdown-item"
                                      onClick={exportExcel}
                                    >
                                      <i className="ti ti-file-type-xls text-green me-1" />
                                      Export as Excel{" "}
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        }

                        {selectedContactKeys.length > 0 &&
                          <>






                            {userProfile.role === "companyAdmin" &&

                              <div className="d-flex align-items-center"
                                style={{
                                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                                  borderRadius: "6px",
                                  padding: "10px",
                                  backgroundColor: "#fff"
                                }}
                              >
                                <Select
                                  options={assignOptions}
                                  value={selectedAssign}
                                  onChange={setSelectedAssign}
                                  placeholder="Select action"
                                  classNamePrefix="react-select"
                                  className="me-2"
                                  styles={{ zIndex: 1000, marginTop: '10px' }}
                                />

                                <div className="me-2">{selectedAssign.value ? "to" : "from"}</div>

                                <Select
                                  options={agentOptions}
                                  value={selectedAgent}
                                  onChange={setSelectedAgent}
                                  placeholder="Assign to agent"
                                  classNamePrefix="react-select"
                                  className="me-2"
                                  styles={{ zIndex: 1000, marginTop: '10px' }}
                                />
                                <button
                                  className="btn btn-theme text-white contacts-delete-btn"
                                  onClick={handleBulkAssignAgent}
                                >
                                  <span className="ms-2">{selectedAssign.value ? "Assign Agent" : "Unassign Agent"}</span>
                                </button>

                              </div>

                            }






                            <div className="d-flex align-items-center"
                              style={{
                                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                                borderRadius: "6px",
                                padding: "10px",
                                backgroundColor: "#fff"
                              }}
                            >
                              <CreatableSelect
                                isMulti
                                options={bulkAllTags}
                                value={bulkSelectedTags}
                                onChange={setBulkSelectedTags}
                                onCreateOption={handleBulkCreateTag}
                                placeholder="Assign to groups"
                                classNamePrefix="react-select"
                                className="me-2"
                                styles={{ zIndex: 1000 }}
                              />
                              <button
                                className="btn btn-primary contacts-delete-btn"
                                onClick={handleBulkAssignTags}
                              >
                                <span className="ms-2">
                                  Assign groups
                                </span>
                              </button>

                            </div>


                            <div className="d-flex align-items-center"
                              style={{
                                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                                borderRadius: "6px",
                                padding: "10px",
                                backgroundColor: "#fff"
                              }}
                            >

                              <button
                                className="btn btn-danger contacts-delete-btn"
                                onClick={() => setShowBatchDeleteModal(true)}
                              >
                                <i className="ti ti-trash" />
                                <span className="ms-2">
                                  Delete Selected ({selectedContactKeys.length})
                                </span>
                              </button>



                            </div>


                          </>}

                        {selectedContactKeys.length == 0 && <Link
                          to=""
                          className="btn btn-primary contacts-add-btn"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#customer_offcanvas"
                          onClick={() => {
                            setSelectedCustomer(null);
                            dispatch(resetSelectedContact());
                          }}
                        >
                          <i className="ti ti-square-rounded-plus" />
                          <span className="ms-2">Add Lead</span>
                        </Link>}
                      </div>
                    </div>

                    {/* Mobile Layout - Keep Current Implementation */}
                    <div className="contacts-header-mobile">
                      <div className="row align-items-center">
                        <div className="col-sm-12">
                          {/* Title Row - Always on top */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="page-header mb-0">
                              <h4 className="page-title mb-0 mt-1">
                                Leads
                                <span className="count-title">
                                  {pagination.totalItems}
                                </span>
                              </h4>
                            </div>
                          </div>

                          {/* Search Row - Separate on mobile */}
                          <div className="contacts-header-search-row mb-3">
                            <div className="icon-form flex-grow-1">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Leads"
                                value={searchQuery}
                                onChange={(text) =>
                                  dispatch(setSearchQuery(text.target.value))
                                }
                              />
                            </div>
                          </div>

                          {/* Action Buttons Row */}
                          <div className="contacts-header-actions">
                            <div className="contacts-actions-left">
                              {!selectedContactKeys.length &&
                                <><div className="form-sorts dropdown me-2">
                                  <Link
                                    to=""
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close="outside"
                                    className="contacts-filter-btn"
                                  >
                                    <i className="ti ti-filter-share m-0" />
                                    <span className="d-none d-sm-inline ms-1">
                                      Filter
                                    </span>
                                  </Link>
                                  <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                                    <div className="filter-set-view">
                                      <div className="filter-set-head">
                                        <h4>
                                          <i className="ti ti-filter-share" />
                                          Filter
                                        </h4>
                                      </div>
                                      <div
                                        className="accordion"
                                        id="accordionExample"
                                      >
                                        <div className="filter-set-content">
                                          <div className="filter-set-content-head">
                                            <Link
                                              to=""
                                              className="collapsed"
                                              data-bs-toggle="collapse"
                                              data-bs-target="#Status"
                                              aria-expanded="false"
                                              aria-controls="Status"
                                            >
                                              Contact Status
                                            </Link>
                                          </div>
                                          <div
                                            className="filter-set-contents accordion-collapse collapse"
                                            id="Status"
                                            data-bs-parent="#accordionExample"
                                          >
                                            <div className="filter-content-list">
                                              <ul>
                                                {contactStatusOptions.map(
                                                  (contactStatus, index) => {
                                                    return (
                                                      <li key={index}>
                                                        <div className="filter-checks">
                                                          <label className="checkboxs">
                                                            <input
                                                              type="checkbox"
                                                              checked={selectedContactStatus.includes(
                                                                contactStatus.value
                                                              )} // Check if status is selected
                                                              onChange={() =>
                                                                filterContactStatus(
                                                                  contactStatus.value
                                                                )
                                                              }
                                                            />
                                                            <span className="checkmarks" />
                                                            <span />
                                                            {contactStatus.label}
                                                          </label>
                                                        </div>
                                                      </li>
                                                    );
                                                  }
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="filter-set-content">
                                          <div className="filter-set-content-head">
                                            <Link
                                              to=""
                                              className="collapsed"
                                              data-bs-toggle="collapse"
                                              data-bs-target="#favourite"
                                              aria-expanded="false"
                                              aria-controls="favourite"
                                            >
                                              Favourites
                                            </Link>
                                          </div>
                                          <div
                                            className="filter-set-contents accordion-collapse collapse"
                                            id="favourite"
                                            data-bs-parent="#accordionExample"
                                          >
                                            <div className="filter-content-list">
                                              <ul>

                                                <li>
                                                  <div className="filter-checks">
                                                    <label className="checkboxs">
                                                      <input
                                                        type="checkbox"
                                                        name="favourite"
                                                        checked={
                                                          selectedIsFavourite ===
                                                          true
                                                        }
                                                        onChange={() =>
                                                          dispatch(
                                                            setSelectedIsFavourite(
                                                              selectedIsFavourite === true ? null : true
                                                            )
                                                          )
                                                        }
                                                      />
                                                      <span className="checkmarks" />
                                                      Favourites Only
                                                    </label>
                                                  </div>
                                                </li>

                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="filter-reset-btns">
                                        <div className="row">
                                          <div className="col-6"></div>
                                          <div className="col-6">
                                            <Link
                                              to=""
                                              className="btn btn-primary"
                                              onClick={resetFilters}
                                            >
                                              Reset
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  <div className="dropdown me-2">
                                    <Link
                                      to=""
                                      className="btn bg-soft-purple text-purple contacts-columns-btn"
                                      data-bs-toggle="dropdown"
                                      data-bs-auto-close="outside"
                                    >
                                      <i className="ti ti-columns-3 me-2" />
                                      <span className="d-none d-sm-inline">
                                        Manage Columns
                                      </span>
                                      <span className="d-inline d-sm-none">
                                        Columns
                                      </span>
                                    </Link>
                                    <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                      <div className="border-top pt-3">
                                        {columns.map((column, index) => {
                                          if (
                                            column.title === "Action" ||
                                            column.title === ""
                                          ) {
                                            return;
                                          }
                                          return (
                                            <div
                                              className="d-flex align-items-center justify-content-between mb-3"
                                              key={index}
                                            >
                                              <p className="mb-0 d-flex align-items-center">
                                                <i className="ti ti-grip-vertical me-2" />
                                                {column.title}
                                              </p>
                                              <div className="status-toggle">
                                                <input
                                                  type="checkbox"
                                                  id={column.title}
                                                  className="check"
                                                  checked={
                                                    !!columnVisibility[column.title]
                                                  }
                                                  onChange={() =>
                                                    handleToggleColumnVisibility(
                                                      column.title
                                                    )
                                                  }
                                                />
                                                <label
                                                  htmlFor={column.title}
                                                  className="checktoggle"
                                                />
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              }
                              <div className="dropdown me-2">
                                <Link
                                  to=""
                                  className="dropdown-toggle contacts-export-btn"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="ti ti-package-export me-2" />
                                  <span className="">Import/Export</span>
                                </Link>
                                <div className="dropdown-menu  dropdown-menu-end">
                                  <ul className="mb-0">
                                    <li>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() => setImportModal(true)}
                                      >
                                        <i className="fa-solid fa-file-arrow-up me-2 text-primary"></i>
                                        Import
                                      </button>
                                    </li>
                                    <li>
                                      <Link
                                        to=""
                                        className="dropdown-item"
                                        onClick={exportPDF}
                                      >
                                        <i className="ti ti-file-type-pdf text-danger me-1" />
                                        Export as PDF
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to=""
                                        className="dropdown-item"
                                        onClick={exportExcel}
                                      >
                                        <i className="ti ti-file-type-xls text-green me-1" />
                                        Export as Excel{" "}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <button
                                className="btn btn-primary  d-flex align-items-center contacts-refresh-btn"
                                onClick={async () => {
                                  dispatch(clearContactsCache());
                                  fetchContacts();
                                }}
                                disabled={loading}
                              >
                                <i
                                  className={`ti ti-refresh fs-5  ${loading ? "ti-spin" : ""
                                    }`}
                                />
                              </button>
                            </div>

                            <div className="contacts-actions-right">
                              {selectedContactKeys.length > 0 && (
                                <button
                                  className="btn btn-danger me-2 contacts-delete-btn"
                                  onClick={() => setShowBatchDeleteModal(true)}
                                >
                                  <i className="ti ti-trash" />
                                  <span className="d-none d-sm-inline ms-2">
                                    Delete Selected (
                                    {selectedContactKeys.length})
                                  </span>
                                  <span className="d-inline d-sm-none ms-2">
                                    ({selectedContactKeys.length})
                                  </span>
                                </button>
                              )}
                              <Link
                                to=""
                                className="btn btn-primary contacts-add-btn"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#customer_offcanvas"
                                onClick={() => {
                                  setSelectedCustomer(null);
                                  dispatch(resetSelectedContact());
                                }}
                              >
                                <i className="ti ti-square-rounded-plus" />
                                <span className="d-none d-sm-inline ms-2">
                                  Add Lead
                                </span>
                                <span className="d-inline d-sm-none ms-2">
                                  Add
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    {/* Contact List */}
                    <div className="table-responsive custom-table h-100">
                      {loading ? (
                        <div className="text-center py-5">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : filteredContactData.length === 0 ? (() => {
                          const isFilterActive =
                            !!searchQuery ||
                            selectedContactStatus.length > 0 ||
                            selectedIsFavourite !== null ||
                            filterTags.length > 0 ||
                            selectedAgents.length > 0;
                          return isFilterActive ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "64px 24px",
                                textAlign: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: 80,
                                  height: 80,
                                  borderRadius: "50%",
                                  background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginBottom: 20,
                                }}
                              >
                                <i className="ti ti-filter-off" style={{ fontSize: 36, color: "#d97706" }} />
                              </div>
                              <h5 style={{ fontWeight: 700, marginBottom: 8, color: "#111827" }}>No leads match your filters</h5>
                              <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24, maxWidth: 320 }}>
                                Try adjusting or clearing your filters to see results.
                              </p>
                              <button
                                className="btn btn-outline-secondary"
                                style={{ borderRadius: 8, padding: "10px 24px", fontWeight: 600, fontSize: 14 }}
                                onClick={resetFilters}
                              >
                                <i className="ti ti-x me-2" />
                                Clear Filters
                              </button>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "64px 24px",
                                textAlign: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: 80,
                                  height: 80,
                                  borderRadius: "50%",
                                  background: "linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginBottom: 20,
                                }}
                              >
                                <i className="ti ti-users" style={{ fontSize: 36, color: "#7c3aed" }} />
                              </div>
                              <h5 style={{ fontWeight: 700, marginBottom: 8, color: "#111827" }}>No leads yet</h5>
                              <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24, maxWidth: 320 }}>
                                You haven&apos;t added any leads. Start building your pipeline by adding your first lead.
                              </p>
                              <Link
                                to=""
                                className="voycell-empty-btn"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#customer_offcanvas"
                                onClick={() => {
                                  setSelectedCustomer(null);
                                  dispatch(resetSelectedContact());
                                }}
                              >
                                <i className="ti ti-square-rounded-plus" />
                                Add Your First Lead
                              </Link>
                            </div>
                          );
                        })() : (
                        <Table
                          dataSource={filteredContactData}
                          columns={visibleColumns}
                          rowKey={(record) => record.key}
                          onSelectionChange={handleRowSelectionChange}
                          selectedRowKeys={selectedContactKeys}
                          pagination={{
                            current: currentPage,
                            pageSize: pageLimit,
                            total: pagination.totalItems,
                            showSizeChanger: true,
                            showQuickJumper: false,
                            pageSizeOptions: ["10", "20", "30", "50", "100", "500"],
                            showTotal: (total, range) =>
                              `Showing ${range[0]}-${range[1]} of ${total} entries`,
                          }}
                          onPaginationChange={(page, pageSize) => {
                            dispatch(setCurrentPage(page));
                            if (pageSize !== pageLimit) {
                              dispatch(setPageLimit(pageSize));
                            }
                          }}
                        />
                      )}
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Contact */}

        <CustomerOffcanvas
          isLead={true}
          selectedCustomer={selectedCustomer}
          onContactUpdated={handleOffcanvasContactUpdate}
        />
        {/* Delete Contact */}
        <div className="modal fade" id="delete_contact" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-theme-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-theme" />
                  </div>
                  <h4 className="mb-2">Remove Leads?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> lead you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to=""
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                      onClick={() => setContactToDelete(null)}
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      className="btn btn-theme text-light"
                      onClick={(e) => handleDeleteContact(e)}
                    >
                      Yes, Delete it
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Contact */}

        {/* Batch Delete Confirmation Modal */}
        <Modal
          show={showBatchDeleteModal}
          onHide={() => setShowBatchDeleteModal(false)}
          centered
        >
          <div className="modal-body">
            <div className="text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                <i className="ti ti-trash-x fs-36 text-danger" />
              </div>
              <h4 className="mb-2">
                {selectedContactKeys.length === 1
                  ? "Delete Lead?"
                  : "Delete Multiple Leads?"}
              </h4>
              <p className="mb-0">
                Are you sure you want to delete {selectedContactKeys.length}{" "}
                selected lead(s)?
                <br />
                This action cannot be undone.
              </p>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <button
                  className="btn btn-light me-2"
                  onClick={() => setShowBatchDeleteModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleBatchDelete}
                >
                  Yes, Delete {selectedContactKeys.length} Contact(s)
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Batch Delete Modal */}

        {/* Create Deal */}
        <Modal show={openModal} onHide={() => setOpenModal(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => setOpenModal(false)}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-medal" />
              </div>
              <h3>Deal Created Successfully!!!</h3>
              <p>View the details of deal, created</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link
                  to=""
                  className="btn btn-light"
                  onClick={() => setOpenModal(false)}
                >
                  Cancel
                </Link>
                <Link
                  to={
                    userProfile.role === "user"
                      ? route.agentLeadsDetails
                      : route.leadsDetails
                  }
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Deal */}
        {/* Create Contact */}
        <Modal show={openModal2} onHide={() => setOpenModal2(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => setOpenModal2(false)}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-user-plus" />
              </div>
              <h3>Contact Created Successfully!!!</h3>
              <p>View the details of contact, created</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link
                  to=""
                  className="btn btn-light"
                  onClick={() => setOpenModal2(false)}
                >
                  Cancel
                </Link>
                <Link
                  to={
                    userProfile.role === "user"
                      ? route.agentLeadsDetails
                      : route.leadsDetails
                  }
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Contact */}
        {/* Access */}
        <div className="modal fade" id="access_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Access For</h5>
                <button
                  className="btn-close custom-btn-close border p-1 me-0 text-dark"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="icon-form mb-3">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                  </div>
                  <div className="access-wrap mb-0">
                    <ul>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-19.jpg"
                              alt=""
                            />
                            <Link to="">Darlee Robertson</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-20.jpg"
                              alt=""
                            />
                            <Link to="">Sharon Roy</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-21.jpg"
                              alt=""
                            />
                            <Link to="">Vaughan</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-01.jpg"
                              alt=""
                            />
                            <Link to="">Jessica</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-16.jpg"
                              alt=""
                            />
                            <Link to="">Carol Thomas</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <img
                              src="assets/img/profiles/avatar-22.jpg"
                              alt=""
                            />
                            <Link to="">Dawn Mercha</Link>
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="d-flex align-items-center justify-content-end m-0">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      data-bs-dismiss="modal"
                      type="button"
                      className="btn btn-primary"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Access */}

        {/* import contacts */}
        <Modal
          show={importModal}
          zIndex={1050}
          onHide={() => setImportModal(false)}
          fullscreen
        >
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              onClick={() => setImportModal(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div>
              <Wizard
                startIndex={0}
              // wrapper={<Wrapper />}
              >
                <Step1 />
                {/* <Step2 /> */}
                <Step3 />
              </Wizard>
            </div>
          </div>
          <div className="modal-footer"></div>
        </Modal>
        {/* import contacts */}

        {/* Country Code Prompt */}
        {/* <CountryCodePrompt
          visible={showCountryCodePrompt}
          onClose={() => {
            setShowCountryCodePrompt(false);
            setPendingImportProvider(null);
          }}
          onConfirm={(countryCode, selectedTags) => {
            setShowCountryCodePrompt(false);
            if (pendingImportProvider) {
              handleImportWithCountryCode(pendingImportProvider, countryCode, selectedTags);
              setPendingImportProvider(null);
            }
          }}
          provider={
            pendingImportProvider === "google"
              ? "Google"
              : pendingImportProvider === "zoho"
                ? "Zoho"
                : "HubSpot"
          }
        /> */}
        <CountryCodePrompt
          visible={showCountryCodePrompt}
          onClose={() => {
            setShowCountryCodePrompt(false);
            setPendingImportProvider(null);
          }}
          // onConfirm={({countryCode, selectedTags,selectedFile}) => {
          //   setShowCountryCodePrompt(false);
          //   if (pendingImportProvider) {
          //     handleImportWithCountryCode(
          //       pendingImportProvider,
          //       countryCode,
          //       selectedTags,
          //       selectedFile
          //     );
          //     setPendingImportProvider(null);
          //   }
          // }}
          onConfirm={({ countryCode, tags, file, newTags }) => {
            setShowCountryCodePrompt(false);
            if (pendingImportProvider) {
              handleImportWithCountryCode(
                pendingImportProvider,
                countryCode,
                tags,
                file,
                newTags
              );
              setPendingImportProvider(null);
            }
          }}
          provider={
            pendingImportProvider === "google"
              ? "Google"
              : pendingImportProvider === "zoho"
                ? "Zoho"
                : pendingImportProvider === "csvExcel"
                  ? "csvExcel"
                  : "HubSpot"
          }
        />
      </div>
      <EmailTemplateModal
        category={"lead"}
        fetchActivities={() => dispatch(clearContactsCache())}
      />
      {/* <WhatsappTemplateModal
        category={"lead"}
        fetchActivities={() => dispatch(clearContactsCache())}
      /> */}
      <WhatsappTemplateModal from={`${selectedContact?.allPhones[0]?.countryCode}${selectedContact?.allPhones[0]?.number}`} />

      {callerModalTarget && (
        <CallerSelectionModal
          destination={callerModalTarget.phone}
          assignedNumbers={userProfile?.assignedExtensions || []}
          defaultCaller={userProfile?.defaultCallerNumber}
          onConfirm={(callerNumber) => {
            dispatch(setCallerAndNumber({ phoneNumber: callerModalTarget.phone, callerNumber }));
            setCallerModalTarget(null);
          }}
          onCancel={() => setCallerModalTarget(null)}
        />
      )}
    </>
  );
};

export default ContactList;
